// import QueryString from "qs";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import apiservice from "../../common/services/apiService"
import * as actions from "../../actions/index"
import dynamic from "next/dynamic";

const Services = dynamic(() => import('../services/services'))
const DigitalProduct = dynamic(() => import('../service-details/digital-product/digital-product'))
const FullPageLoader = dynamic(() => import('../FullPageLoader/FullPageLoader'))
const ServiceDetails = dynamic(() => import('../service-details/service-details-layout/service-details-layout'))
const ServiceDetailsNew = dynamic(() => import('../service-details-new/service-details-layout'))
const HocHead = dynamic(() => import('../HigherOrderComponent/HocHead'))

const ServicePage = (props) => {
	const slug = props.slug;
	const loading = useSelector(state => state.loaderReducer.loading)
	const dispatch = useDispatch();

	const sdata = props.data;
	const data = sdata.data[0].attributes;
	const seo = sdata.data[0].attributes.seo;
	const blocks = sdata.data[0].attributes.blocks;

	useEffect(() => {
		dispatch(actions.hideLoader());

	}, []);



	function SwitchCase(props) {
		if (data.design === "new") {
			return <ServiceDetailsNew blocks={blocks} />;
		} else {
			switch (props.title) {
				case "Services":
					return <Services blocks={blocks}></Services>;
				case "Digital Products Design":
					return <DigitalProduct blocks={blocks}></DigitalProduct>
				default:
					return <ServiceDetails blocks={blocks}></ServiceDetails>;
			}
		}
	}

	return (
		<>
			{seo && <HocHead seo={seo} />}

			{loading && <FullPageLoader />}

			<SwitchCase title={data.title}></SwitchCase>
			{/* { loading ? <FullPageLoader /> : <SwitchCase title={data.title}></SwitchCase> } */}
		</>
	);
};

export default ServicePage;
